import PropTypes from 'prop-types';
import './Panel.css';

Panel.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};
export function Panel({ header, children, footer, styles }) {
  return <div className="panel" style={{ ...styles }}>
    {header && <div className="panelHeader">{header}</div>}
    <div>{children}</div>
    {footer && <div className="panelFooter">{footer}</div>}
  </div>;
}

export default Panel;